export default __webpack_public_path__ + "static/k8s-bee-dba846c4a16e239dab72a65543d63cea.png";